import { gql } from 'apollo-boost';

export const GET_ALL_ANALYTICS = gql`
    query GetAnalytics($limit: Int, $offset: Int) {
        getAnalytics(limit: $limit, offset: $offset) {
            users {
                id
            }
            total
            hasMore
        }
    }
`;
